export default {
  set(name, value, min) {
    var now = new Date();
    //设置时间
    now.setMinutes(now.getMinutes() + min)
    document.cookie = name + "=" + escape(value) + ";expires=" + now.toUTCString();
  },
  get(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
      return unescape(arr[2]);
    else
      return null;
  },
  remove(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.get(name);
    if (cval != null)
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/cookie.js